import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

function GlobalFooter() {
  var today = new Date(),
    date = today.getFullYear();
  return (
    <React.Fragment>
      <footer id="footer" className="global-footer mt-auto">
        <Container>
          <div className="container">
            <div className="row">
              <div className="full">
                <ul className="footer-links">
                  <li>
                    <a href="#skip-to-content">Back to Top</a>
                  </li>
                  <li>
                    <a
                      href="http://hwts.dtsc.ca.gov/Internal_CUPA_Disclaimer.pdf"
                      target="_"
                    >
                      Disclaimer & Data Limitations
                    </a>
                  </li>
                  <li>
                    <a href="https://ca.gov/Accessibility/">Accessibility</a>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Container>
        {/* <!-- Copyright Statement --> */}
        <div className="copyright">
          <div className="container">
            Copyright &copy; &nbsp;
            {date} State of California
          </div>
        </div>
      </footer>
      {/* <!-- Extra Decorative Content --> */}
      <div className="decoration-last">&nbsp;</div>
    </React.Fragment>
  );
}

export default GlobalFooter;
